import { render } from "./teachResearchAdd.vue?vue&type=template&id=2b40d349&scoped=true"
import script from "./teachResearchAdd.vue?vue&type=script&lang=js"
export * from "./teachResearchAdd.vue?vue&type=script&lang=js"

import "./teachResearchAdd.vue?vue&type=style&index=0&id=2b40d349&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b40d349"]])

export default __exports__